import { render, staticRenderFns } from "./onlineShop.vue?vue&type=template&id=16af8689&scoped=true&"
import script from "./onlineShop.vue?vue&type=script&lang=js&"
export * from "./onlineShop.vue?vue&type=script&lang=js&"
import style0 from "./onlineShop.vue?vue&type=style&index=0&id=16af8689&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af8689",
  null
  
)

export default component.exports